@if (supplier.source === 'user') {
<span class="badge user-set" title="ค่าที่ตั้งเอง sync จะไม่เขียนทับ">ตั้งเอง</span>
}
@if (supplier.needsReview) {
<span
    class="badge"
    [title]="supplier.reviewNote ?? 'ยังไม่แน่ใจว่าเป็นสินค้านี้ ต้องตรวจ'"
    >ตรวจ</span
>
}
@for (part of supplier.parts; track $index) {
<a
    class="supplier-link"
    [href]="part.url"
    target="_blank"
    rel="noopener noreferrer"
    (click)="$event.stopPropagation()"
    [title]="
        (part.partName ? part.partName + ' · ' : '') +
        part.label +
        ' · ' +
        part.offerTitle
    "
    >{{ part.label }}</a
>
@if (part.packQty > 1) {
<span class="badge" title="1 หน่วยในร้าน = {{ part.packQty }} หน่วยบน 1688"
    >×{{ part.packQty }}</span
>
}
}
